import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { AppLoadingService } from '@app/services';
import { Loading } from './shared/components/loading/loading';
import { Offline } from './shared/components/offline/offline';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ButtonModule, ToastModule, Loading, Offline],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('mento-academy');

  private readonly router = inject(Router);
  private readonly loader = inject(AppLoadingService);

  constructor() {
    // Global route-transition loading: show the overlay while a navigation is
    // in flight (covers lazy-route chunk loads and resolvers) and hide it once
    // the navigation settles — succeeds, is cancelled, or errors. show/hide are
    // reference-counted, so overlapping navigations stay balanced.
    this.router.events.pipe(takeUntilDestroyed()).subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loader.show();
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loader.hide();
      }
    });
  }
}
